import React from 'react';
import {
    withStyles,
    Grid,
    Typography,
    ListItem,
    Avatar,
    Divider,
} from '../../material-ui';

class ChatAddedItem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    _onListItemClick = () => {
        this.props.onClick && this.props.onClick();
    }

    render() {
        const { classes, data, end } = this.props;
        return (
            <ListItem disableRipple button onClick={() => this._onListItemClick()} className={classes.root}>
                <Grid container direction='row' alignItems='center'>
                    <Grid container direction='row' alignItems='center' justifyContent='space-between'>
                        <Grid container direction='row' alignItems='center' style={{ flex: 1, paddingLeft: 8 }}>
                            <Avatar src={data.headurl} className={classes.menuIcon} />
                            <Grid style={{ marginLeft: 8 }}>
                                <Grid container direction='row' alignItems='center' >
                                    <Typography style={{ fontSize: 14, color: '#0D0D0D' }}>{data.nickname}</Typography>
                                    <Typography style={{ fontSize: 9, color: '#878787', marginLeft: 8 }}>{data.time}</Typography>
                                </Grid>
                                <Typography style={{ fontSize: 9, color: '#878787', marginTop: 4 }}>{data.desc}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container direction='row' alignItems='center' justifyContent='flex-end' style={{ flex: 1, paddingRight: 24 }}>
                            <Typography className={classes.refuseButton}>已添加</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Divider className={end ? classes.divider1 : classes.divider}></Divider>
            </ListItem>
        );
    }
}
export default withStyles((theme) => ({
    root: {
        margin: theme.spacing(1, 0, 1, 0),
        padding: 0,
        flexDirection: 'column'
    },
    menuIcon: {
        width: 40,
        height: 40,
    },
    refuseButton: {
        borderRadius: 4,
        color: '#878787',
        fontSize: 12,
    },
    divider: {
        backgroundColor: '#FAFAFA',
        height: 1,
        width: 'calc(100% - 56px)',
        marginLeft: 56,
        marginTop: 4
    },
    divider1: {
        backgroundColor: '#FAFAFA',
        height: 1,
        width: '100%',
        marginTop: 8
    },
}))(ChatAddedItem);
